import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  calendarHolidays: Boundaries["removeCalendarHolidays"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.calendarHolidays.uuid === calendarHolidays.uuid,
  );
  return index !== -1
    ? [
        ...state.slice(0, index),
        { calendarHolidays, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { calendarHolidays, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  calendarHolidays: Boundaries["removeCalendarHolidays"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.calendarHolidays.uuid === calendarHolidays.uuid,
  );
  return index !== -1
    ? [
        ...state.slice(0, index),
        { calendarHolidays, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { calendarHolidays, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  calendarHolidays: Boundaries["removeCalendarHolidays"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.calendarHolidays.uuid === calendarHolidays.uuid,
  );
  return index !== -1
    ? [
        ...state.slice(0, index),
        { calendarHolidays, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { calendarHolidays, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeCalendarHolidaysRequested]: handleRequest,
    [events.removeCalendarHolidaysSucceeded]: handleSuccess,
    [events.removeCalendarHolidaysFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
